
import React from 'react';
import { Play } from 'lucide-react';

const PromoVideo: React.FC = () => {
  return (
    <div className="mt-10 px-2.5 md:px-0">
      <h2 className="text-xl font-medium mb-3">What is Gozango?</h2>
      <div className="relative rounded-lg overflow-hidden aspect-video bg-gray-100 shadow-md">
        {/* Placeholder video thumbnail */}
        <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
          <div className="h-16 w-16 rounded-full bg-white/80 backdrop-blur flex items-center justify-center cursor-pointer hover:bg-white transition-colors">
            <Play size={32} className="text-green-600 ml-1" />
          </div>
        </div>
        
        {/* Video thumbnail */}
        <img
          src="https://images.unsplash.com/photo-1605810230434-7631ac76ec81"
          alt="Gozango promo video thumbnail"
          className="w-full h-full object-cover"
        />
      </div>
      <p className="text-sm text-gray-600 mt-2">
        Learn how Gozango can help grow your business with our smart marketing tools and lead generation platform.
      </p>
    </div>
  );
};

export default PromoVideo;
